import React, { useState, useEffect } from "react";
import { Select, TYPE } from "baseui/select";

export default function CustomMultiSelect(props) {
  const {
    items,
    onChange,
    size = "default", // default, compact, or large
    value,
    overrides = {},
    ...otherProps
  } = props;

  // Ensuring the provided 'value' prop is in the correct format
  const [selectedValues, setSelectedValues] = useState(value || []);
  // Effect to update state when value prop changes
  useEffect(() => {
    setSelectedValues(value || []);
  }, [value]);
  function handleChange({ value }) {
    setSelectedValues(value);

    if (Array.isArray(value)) {
      onChange(value);
    } else {
      console.error("Unexpected value structure:", value);
    }
  }

  return (
    <Select
      options={items}
      labelKey="label"
      valueKey="id"
      type={TYPE.select}
      searchable={false}
      multi
      size={size}
      onChange={handleChange}
      value={selectedValues} // No need for conversion here
      overrides={overrides}
      {...otherProps}
    />
  );
}
